/**
 * Rotas que abrem sem sessão.
 *
 * Mora aqui, e não no `proxy.ts`, porque tem dois consumidores: o proxy, que
 * decide quem precisa de login, e o cliente, que trata essas páginas como
 * vitrine (quem chega nelas ainda não é usuário, e é nelas que o Web Vitals
 * pesa no SEO). O `proxy.ts` chama `getWebEnv()` no topo do módulo, então
 * importar dele no cliente arrastaria a validação de ambiente do servidor.
 */
const PUBLIC_PATH_MATCHERS: ReadonlyArray<RegExp> = [
  /^\/$/,
  /^\/sign-in(?:\/.*)?$/,
  /^\/sign-up(?:\/.*)?$/,
  /^\/forgot-password(?:\/.*)?$/,
  /^\/waitlist(?:\/.*)?$/,
  /^\/redirect(?:\/.*)?$/,
  /^\/from(?:\/.*)?$/,
  /^\/sign-out(?:\/.*)?$/,
  /^\/auth\/oauth\/callback(?:\/.*)?$/,
  /^\/auth\/impersonate(?:\/.*)?$/,
  /^\/auth\/stage-access(?:\/.*)?$/,
  /^\/forbidden(?:\/.*)?$/,
  // Termos e política precisam abrir sem sessão: quem ainda não se cadastrou é
  // justamente quem tem motivo para lê-los. Nos três idiomas.
  /^(?:\/(?:en|es))?\/termos-de-uso$/,
  /^(?:\/(?:en|es))?\/politica-de-privacidade$/,
  // Só o corpo dos Termos, embutido no reaceite (TAM-305): o app e o desktop
  // o carregam numa WebView/iframe, e o reaceite acontece antes de tudo.
  /^\/embed\/(?:pt|en|es)\/termos-de-uso$/,
  // O texto de uma publicação guardada, lançada ou não: o «Ver o texto» do
  // admin. São textos públicos, só ainda não em vigor.
  /^\/embed\/(?:pt|en|es)\/publicacao\/[0-9a-f]{12}-[0-9a-f]{12}\/(?:termos-de-uso|politica-de-privacidade)$/,
  // Demo de marketing: é para quem ainda não tem conta, e sem essa entrada
  // fica inalcançável (redireciona pro login antes de mostrar o produto).
  /^\/demo$/,
  // Link da bio do Instagram: o público dela é justamente quem não tem
  // conta. Atrás do login ela não serve para nada.
  /^\/links$/,
  // A API informa esta URL à Meta como confirmação de exclusão de dados
  // (`SocialConnectionWebhook.controller.ts`). Quem chega aqui vem de fora e
  // sem sessão — no App Review, quem chega é o revisor. Atrás do login, a
  // submissão é reprovada.
  /^\/privacidade\/exclusao$/,
  // Fim da conexão oficial de rede iniciada no desktop: abre no navegador do
  // sistema, que não tem a sessão do app (`social-connection-return.ts` na API).
  /^\/social-connection\/done$/,
  // Fim da ida ao Stripe (portal ou renovação) iniciada no desktop: mesmo
  // motivo, o navegador do sistema não tem a sessão (`billing-return.ts` na API).
  /^\/billing-return\/done$/,
];

export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATH_MATCHERS.some((re) => re.test(pathname));
}
